import React from 'react';
import {
    Page,
    Card,
    Button,
    Layout,
    Stack,
    Icon,
    Link
} from '@shopify/polaris';
import {
    TickMinor
} from '@shopify/polaris-icons';
import { Helmet } from 'react-helmet';
import { apiFetch as fetch } from '../common/Helpers';
import { AppContext } from '../common/AppContext';

class PlansPage extends React.Component {

    state = {
        storeInfo: {}
    };

    render() {

        return (
            <div>
                <Helmet>
                    <title>Tag Genie - Change Plan</title>
                </Helmet>
                <Page title="Change Plan">
                    <Layout>
                        <Layout.Section>
                            <Card title="What You Get" sectioned>
                                <Stack vertical spacing="tight">
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Best Tag Management App for Shopify</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Unlimited operations</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>All features</p>
                                        </Stack>
                                    </Stack.Item>
                                    <Stack.Item>
                                        <Stack alignment="center">
                                            <Icon source={TickMinor} color="success" backdrop />
                                            <p>Premium support</p>
                                        </Stack>
                                    </Stack.Item>
                                </Stack>
                                <br />
                                <p>For detailed list of all features and pricing information please visit our <Link url="https://taggenieapp.com/pricing">Pricing page</Link></p>
                            </Card>
                        </Layout.Section>
                        <Layout.Section>
                            <Card title="Choose new plan">
                                <Card.Section>
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe("PlanLiteShopify")}>Subscribe for $5/month</Button>
                                    </div>
                                    <br />
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe("PlanBasicShopify")}>Subscribe for $9/month</Button>
                                    </div>
                                    <br />
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe("PlanShopify")}>Subscribe for $15/month</Button>
                                    </div>
                                    <br />
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe("PlanAdvancedShopify")}>Subscribe for $30/month</Button>
                                    </div>
                                    <br />
                                    <div>
                                        <Button primary={true} onClick={() => this.handleSubscribe("PlanShopifyPlus")}>Subscribe for $50/month</Button>
                                    </div>
                                    <br />
                                </Card.Section>
                            </Card>
                        </Layout.Section>
                    </Layout>
                </Page>
            </div >
        );
    }

    handleSubscribe(planName) {
        fetch(`api/storeConnections/changePlanRequest`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "planTier": planName,
                "skipTrial": true
            })
        }).then(response => response.json())
            .then((data) => {

                if (data.confirmationUrl != null) {
                    window.location.href = data.confirmationUrl;
                }
            });
    }

    componentDidMount() {
    }
}

PlansPage.contextType = AppContext;

export default PlansPage;